/* eslint-disable @typescript-eslint/no-explicit-any */ import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _instanceof from "@swc/helpers/src/_instanceof.mjs";
import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import _to_consumable_array from "@swc/helpers/src/_to_consumable_array.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { getStories, getStoryBySlug } from "@cinch-nx/data-storyblok";
import { tagError, traceFunction } from "@core/datadog-server";
var instrumentedGetStoryBySlug = traceFunction("getStoryBySlug", getStoryBySlug);
var instrumentedGetStories = traceFunction("getStories", getStories);
export function getStaticPropsGenerator(param) {
    var subHubPath = param.subHubPath, _resultsPerPage = param.resultsPerPage, resultsPerPage = _resultsPerPage === void 0 ? 10 : _resultsPerPage, _breadCrumbs = param.breadCrumbs, breadCrumbs = _breadCrumbs === void 0 ? [] : _breadCrumbs, _generatePageBreadcrumb = param.generatePageBreadcrumb, generatePageBreadcrumb = _generatePageBreadcrumb === void 0 ? false : _generatePageBreadcrumb;
    return function() {
        var _ref = _async_to_generator(function(param) {
            var _preview, preview, params, version, localBreadcrumbs, currentPage, ref, subHubStory, ref1, articles, numberOfArticles, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _preview = param.preview, preview = _preview === void 0 ? false : _preview, params = param.params;
                        version = preview ? "draft" : "published";
                        localBreadcrumbs = _to_consumable_array(breadCrumbs);
                        currentPage = 1;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        if (typeof (params === null || params === void 0 ? void 0 : params.page) === "string") {
                            if ((params === null || params === void 0 ? void 0 : params.page) === "1") {
                                // Redirect [sub-hub]/page/1 to [sub-hub]/
                                return [
                                    2,
                                    {
                                        redirect: {
                                            permanent: true,
                                            destination: "/".concat(subHubPath)
                                        }
                                    }
                                ];
                            } else {
                                currentPage = Number.parseInt(params.page);
                            }
                        }
                        return [
                            4,
                            Promise.all([
                                getSubHubStory({
                                    subHubPath: subHubPath,
                                    version: version
                                }),
                                getArticlesForPage({
                                    subHubPath: subHubPath,
                                    version: version,
                                    perPage: resultsPerPage,
                                    page: currentPage
                                })
                            ])
                        ];
                    case 2:
                        ref = _sliced_to_array.apply(void 0, [
                            _state.sent(),
                            2
                        ]), subHubStory = ref[0], ref1 = ref[1], articles = ref1.articles, numberOfArticles = ref1.total;
                        subHubStory.content.title = subHubStory.content.title || breadCrumbs[breadCrumbs.length - 1].text;
                        if (generatePageBreadcrumb && currentPage !== 1) {
                            localBreadcrumbs.push({
                                text: "Page ".concat(currentPage),
                                url: "/".concat(subHubPath, "/page/").concat(currentPage)
                            });
                        }
                        return [
                            2,
                            {
                                props: {
                                    preview: preview,
                                    story: subHubStory,
                                    path: subHubPath,
                                    currentPage: currentPage,
                                    numberOfArticles: numberOfArticles,
                                    resultsPerPage: resultsPerPage,
                                    articles: articles,
                                    layoutProps: {
                                        showBorderRadius: true,
                                        breadCrumbs: localBreadcrumbs
                                    },
                                    generatedAt: Date.now()
                                },
                                revalidate: 60
                            }
                        ];
                    case 3:
                        error = _state.sent();
                        console.log(error);
                        if (typeof error === "string" || _instanceof(error, Error)) {
                            tagError(error);
                        }
                        return [
                            2,
                            {
                                notFound: true,
                                revalidate: 60
                            }
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }();
}
function toArticle(subhubPath) {
    var _published_at;
    return function(input) {
        return {
            path: "/".concat(subhubPath, "/").concat(input.slug),
            title: input.content.title,
            image: input.content.image,
            date: (_published_at = input.published_at) !== null && _published_at !== void 0 ? _published_at : ""
        };
    };
}
function getSubHubStory(_) {
    return _getSubHubStory.apply(this, arguments);
}
function _getSubHubStory() {
    _getSubHubStory = _async_to_generator(function(param) {
        var subHubPath, version, story;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    subHubPath = param.subHubPath, version = param.version;
                    return [
                        4,
                        instrumentedGetStoryBySlug("articles/hubs/".concat(subHubPath), {
                            version: version
                        })
                    ];
                case 1:
                    story = _state.sent();
                    if (!story || !story.content || story.content.component !== "ArticlesSubHubPage") {
                        throw new Error("Failed to load story for sub-hub ".concat(subHubPath));
                    }
                    return [
                        2,
                        story
                    ];
            }
        });
    });
    return _getSubHubStory.apply(this, arguments);
}
function getArticlesForPage(_) {
    return _getArticlesForPage.apply(this, arguments);
}
function _getArticlesForPage() {
    _getArticlesForPage = _async_to_generator(function(param) {
        var subHubPath, version, page, perPage, articleStories;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    subHubPath = param.subHubPath, version = param.version, page = param.page, perPage = param.perPage;
                    return [
                        4,
                        instrumentedGetStories({
                            version: version,
                            starts_with: "articles/".concat(subHubPath),
                            page: page,
                            per_page: perPage,
                            sort_by: "published_at:desc"
                        }).catch(function() {
                            return {
                                stories: [],
                                total: 0
                            };
                        })
                    ];
                case 1:
                    articleStories = _state.sent();
                    if (articleStories.stories.length === 0) {
                        throw new Error('no articles available for "articles/'.concat(subHubPath, '" page ').concat(page));
                    }
                    return [
                        2,
                        {
                            articles: articleStories.stories.map(toArticle(subHubPath)),
                            total: Number(articleStories.total)
                        }
                    ];
            }
        });
    });
    return _getArticlesForPage.apply(this, arguments);
}
